import React, { useEffect } from "react";

const SubjectChangeDenied = ({ history }) => {
  useEffect(() => {
    const timeout = setTimeout(() => {
      history.push("/");
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return (
    <div>
      Odabrali ste poslovni subjekt za kojeg niste ovlaštena osoba, niti imate
      punomoć.
      <div>Preusmjeravamo Vas na početnu stranicu...</div>
    </div>
  );
};

export default SubjectChangeDenied;
